import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotaryCompressor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 42,
	height: 91,
	viewBox: "0 0 42.0 91.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 7.5 82.0 L 0.0 91.0 L 42.0 91.0 L 34.4 82.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 41.0 10.0 L 41.0 75.0 A 20.0 10.0 0.0 0 1 1.0 75.0 L 1.0 10.0 A 20.0 10.0 0.0 0 1 41.0 10.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 23,
			rx: 16,
			ry: 16,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 60,
			rx: 16,
			ry: 16,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgRotaryCompressor;
